import { take } from 'rxjs';
import { ColumnsShowService } from './../../../core/services/columns-show.service';
import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { MultiSelect } from 'primeng/multiselect';
@Component({
  selector: 'app-setting-dropdown',
  templateUrl: './setting-dropdown.component.html',
  styleUrls: ['./setting-dropdown.component.css']
})
export class SettingDropdownComponent implements OnInit {

  @Input() tableName: string = '';
  @Input() tableOptions: any[] = [];
  @ViewChild('multiSelect') multiSelect!: MultiSelect;
  @Output() ChoosedOptions = new EventEmitter();

  showDropdown: boolean = false;
  selected: any = {}
  AllSelected: any = {}
  constructor(private col:ColumnsShowService) { }
  ngOnInit(): void {
    this.selected = this.tableOptions;
    if (this.col.tableShow[this.tableName]) {
      this.selected = this.col.tableShow[this.tableName];
      const missing = this.tableOptions.filter((option: string) => !this.selected.includes(option));
      if (missing.length) {
        this.selected = [...this.selected, ...missing];
        this.col.tableShow[this.tableName] = this.selected;
      }
    } else {
      this.col.tableShow[this.tableName] = this.selected;
    }
    // Emit after a tick so parent view is ready
    setTimeout(() => {
      this.emitOutput(this.col.getObject(this.col.tableShow[this.tableName]));
    });
  }
  onChange(event:any){
    if(this.selected.length==0){
      if(event?.itemValue){
        this.selected.push(event?.itemValue)
      }
      else{
        this.selected.push(...this.tableOptions)
      }
    }
    this.col.tableShow[this.tableName] = this.selected
    this.emitOutput(this.col.getObject(this.col.tableShow[this.tableName]))
  }
  toggleDropdown() {
    this.multiSelect.show();
  }
  emitOutput(object:any) {
    this.ChoosedOptions.emit(object);
  }
}
